import {
  BHS_HOSTNAMES,
  PCE_HOSTNAMES,
  YWC_HOSTNAMES,
  CUREWIKI_HOSTNAMES,
  PEC_HOSTNAMES,
} from '@app/constants';
import { Domains } from '../hooks';

export const isCurewiki =
  import.meta.env.VITE_APP_TYPE === Domains.CUREWIKI ||
  (typeof window !== 'undefined' && CUREWIKI_HOSTNAMES.includes(window.location.hostname));

export const isYWC =
  import.meta.env.VITE_APP_TYPE === Domains.YWC ||
  (typeof window !== 'undefined' && YWC_HOSTNAMES.includes(window.location.hostname));

export const isBHS =
  import.meta.env.VITE_APP_TYPE === Domains.BHS ||
  (typeof window !== 'undefined' && BHS_HOSTNAMES.includes(window.location.hostname));

export const isPCE =
  import.meta.env.VITE_APP_TYPE === Domains.PCE ||
  (typeof window !== 'undefined' && PCE_HOSTNAMES.includes(window.location.hostname));

export const isPEC =
  import.meta.env.VITE_APP_TYPE === Domains.PEC ||
  (typeof window !== 'undefined' && PEC_HOSTNAMES.includes(window.location.hostname));
